import React, { Component } from 'react';
import * as dates from '@simplybenefits/sb-dates';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TextInput, Modal, Services, i18n, tokens, Text, BubbleSelectBlock } from '@simplybenefits/sb-ui-library';
import FormControl from "@mui/material/FormControl";
import { updateAdvisorSettings } from '../../../actions/advisor.js';

class AdvisorSettings extends Component {
    state = {
        firstname: '',
        lastname: '',
        companyName: '',
        email: '',
        language: '',
        showModal: false,
        useMFA: false
    };

    componentDidMount() {
        const { meta } = this.props;

        this.setState({
            firstname: meta.firstname,
            lastname: meta.lastname,
            companyName: meta.company,
            email: meta.email,
            useMFA: meta.useMFA,
            language: meta.language === "fr" ? "Français" : "English"
        });
    }

    _onBlur = async (type) => {
        this.setState({
            [`${ type }Error`]: await Services.validateInput(type, this.state[type])
        });
    };

    _handleInputChange = (type, event, isValue = false) => {
        this.setState({
            [type]: isValue ? event : event.target.value.trim()
        });
    };

    _confirm = async () => {
        const firstnameError = await Services.validateInput('firstname', this.state.firstname);
        const lastnameError = await Services.validateInput('lastname', this.state.lastname);
        const companyNameError = await Services.validateInput('companyName', this.state.companyName);
        const emailError = await Services.validateInput('email', this.state.email);

        this.setState({
            firstnameError,
            lastnameError,
            companyNameError,
            emailError
        });

        if (
            firstnameError ||
            lastnameError ||
            companyNameError ||
            emailError
        ) {
            return false;
        }

        const body = {
            firstname: this.state.firstname,
            lastname: this.state.lastname,
            company: this.state.companyName,
            email: this.state.email,
            useMFA: Boolean(this.state.useMFA),
            language: this.state.language === "Français" ? "fr" : "en"
        };

        const success = await this.props.dispatch(updateAdvisorSettings(body));

        if (success) {
            this.props.hideModal();
        }

        return null;
    };

    render() {
        const { hideModal, showModal } = this.props;

        const environment = process.env.REACT_APP_ENVIRONMENT;
        let portalUrl = null;

        switch (environment) {
            case 'local':
                portalUrl = `http://localhost:3000`;
                break;
            case 'staging':
                portalUrl = 'https://member-staging.simplybenefits.ca';
                break;
            case 'production':
                portalUrl = 'https://member.simplybenefits.ca';
                break;
            default:
                break;
        }

        return (
            <Modal
                open={showModal}
                medium={ true }
                onClose={hideModal}
                title={ i18n.t(tokens.labels.account.modifyDetails) }
                primaryButton={{
                    onClick: this._confirm
                }}
                loader={this.props.loader}
            >
                <TextInput
                    label={ i18n.t(tokens.labels.firstname) }
                    value={this.state.firstname}
                    onBlur={() => this._onBlur('firstname')}
                    onChange={(value) => this._handleInputChange('firstname', value)}
                    error={Boolean(this.state.firstnameError)}
                    helperText={this.state.firstnameError}
                    fullWidth
                    autofocus
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            this._confirm();
                            e.preventDefault();
                        }
                    }}
                />

                <TextInput
                    label={ i18n.t(tokens.labels.lastname) }
                    value={this.state.lastname}
                    onBlur={() => this._onBlur('lastname')}
                    onChange={(value) => this._handleInputChange('lastname', value)}
                    error={Boolean(this.state.lastnameError)}
                    helperText={this.state.lastnameError}
                    fullWidth
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            this._confirm();
                            e.preventDefault();
                        }
                    }}
                />

                <TextInput
                    label={ i18n.t(tokens.labels.account.companyName)}
                    value={this.state.companyName}
                    onBlur={() => this._onBlur('companyName')}
                    onChange={(value) => this._handleInputChange('companyName', value)}
                    error={Boolean(this.state.companyNameError)}
                    helperText={this.state.companyNameError}
                    fullWidth
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            this._confirm();
                            e.preventDefault();
                        }
                    }}
                />

                <TextInput
                    label={ i18n.t(tokens.labels.email) }
                    value={this.state.email}
                    onBlur={() => this._onBlur('email')}
                    onChange={(value) => this._handleInputChange('email', value)}
                    error={Boolean(this.state.emailError)}
                    helperText={this.state.emailError}
                    fullWidth
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            this._confirm();
                            e.preventDefault();
                        }
                    }}
                />

                <TextInput
                    label={ i18n.t(tokens.labels.signup.language) }
                    value={ this.state.language }
                    onBlur={() => this._onBlur('language')}
                    onChange={(value) => this._handleInputChange('language', value)}
                    select
                    selectOptions={ Services.selectFieldOptions.languageOptionsNotTranslated() }
                    fullWidth
                />

                <FormControl component="fieldset">
                    <Text
                        medium
                        bold
                        margin="20px 0 0px 0"
                    >
                        { i18n.t(tokens.labels.account.enforceMFA) }
                    </Text>

                    <Text
                        tiny
                        light
                        margin="5px 0 5px 0"
                    >
                        { i18n.t(tokens.labels.account.enforceMFAMessage) }
                    </Text>

                    <BubbleSelectBlock
                        first={{
                            title: i18n.t(tokens.labels.yes),
                            selected: Boolean(this.state.useMFA) === true,
                            field: 'enforceMFAYes'
                        }}
                        second={{
                            title: i18n.t(tokens.labels.no),
                            selected: Boolean(this.state.useMFA) === false,
                            field: 'enforceMFANo'
                        }}
                        onBlur={(e) => this._onBlur('useMFA', e)}
                        handleChange={ async (field) => {
                            if (field === 'enforceMFAYes') {
                                await this._handleInputChange('useMFA', true, true);
                            } else {
                                await this._handleInputChange('useMFA', false, true);
                            }
                        }}
                    />
                </FormControl>

                {
                    this.props.meta.marketplaceAffiliateLink.affiliateLinkID &&
                        <div>
                            <Text
                                medium
                                bold
                                margin="20px 0 0px 0"
                            >
                                { i18n.t(tokens.labels.advisor.marketplaceAffiliateLinkTitle) }
                            </Text>

                            <Text
                                small
                                margin="5px 0 5px 0"
                            >
                                { i18n.t(tokens.labels.advisor.marketplaceAffiliateLinkTag) }
                            </Text>

                            <div style={{
                                display: 'block',
                                position: 'relative',
                                background: '#fff',
                                padding: "10px 20px",
                                borderRadius: '8px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                border: '1px solid #eee',
                                marginTop: "20px",
                                width: "750px"
                            }}>
                                <Text small bold margin="5px 0 5px 0">
                                    URL
                                </Text>

                                <Text small light margin="5px 0 5px 0">
                                    { `${ portalUrl }/signup/affiliate/marketplace/${ this.props.meta.marketplaceAffiliateLink.affiliateLinkID }` }
                                </Text>

                                <Text small bold margin="5px 0 5px 0">
                                    { i18n.t(tokens.labels.infoModal.groupNumber) }
                                </Text>

                                <Text small light margin="5px 0 5px 0">
                                    { this.props.meta.marketplaceAffiliateLink.groupNum }
                                </Text>

                                <Text small bold margin="5px 0 5px 0">
                                    { i18n.t(tokens.labels.advisor.marketplaceAffiliateLinkExpiry) }
                                </Text>

                                <Text small light margin="5px 0 5px 0">
                                    { this.props.meta.marketplaceAffiliateLink.expiry ? dates.getUTC(this.props.meta.marketplaceAffiliateLink.expiry, 'MMM DD, YYYY') : null }
                                </Text>
                            </div>
                        </div>
                }
            </Modal>
        );
    }
}

AdvisorSettings.propTypes = {
    meta: PropTypes.object,
    whitelabel: PropTypes.object
};

/**
 * @param state
 * @returns {{meta: null, loading: boolean}}
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    meta: state.advisor.meta,
    whitelabel: state.whitelabel
});

export default connect(mapStateToProps)(AdvisorSettings);